export default {
  USER: 'user',
  TOKEN: 'token',
  LOGS: 'logs',
  JWT: 'jwt',
  SLAVE_ID: 'slave_id',
  SLAVE_DEVICE_INFO: 'slave_device_info',
};
